<template>
    <div>
        <router-view />  
    </div>
</template>
<script>
export default {
    name: 'my'
}
</script>
<style lang="less" scoped>

</style>